import { FC, PropsWithChildren } from 'react';

import './style.scss';

export const ListWrapper: FC<PropsWithChildren<{ isNumber: boolean }>> = ({ isNumber, children }) => {
  return isNumber ? (
    <ol className="experience-answer-ol">{children}</ol>
  ) : (
    <ul className="experience-answer-list">{children}</ul>
  );
};
